"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecificPlatform = exports.SpecificMobileDevice = exports.getPlatform = exports.Device = void 0;
var REGEX_TABLET = /(tablet|ipad|playbook|kindle)|^((?!mobile).)*$/i;
var REGEX_MOBILE = /mobile|ip(hone|od|ad)|android|blackberry|iemobile|kindle|playbook|netfront|silk-accelerated|(hpw|web)os|fennec|minimo|opera m(obi|ini)|blazer|dolfin|dolphin|skyfire|zune/i;
var Device;
(function (Device) {
    Device["Desktop"] = "desktop";
    Device["Tablet"] = "tablet";
    Device["Mobile"] = "mobile";
})(Device = exports.Device || (exports.Device = {}));
var isMobile = function (userAgent) { return userAgent.match(REGEX_MOBILE); };
var isTablet = function (userAgent) { return userAgent.match(REGEX_TABLET); };
exports.getPlatform = function (userAgent) {
    if (userAgent === undefined) {
        return Device.Desktop;
    }
    if (isMobile(userAgent)) {
        return isTablet(userAgent) ? Device.Tablet : Device.Mobile;
    }
    return Device.Desktop;
};
var SpecificMobileDevice;
(function (SpecificMobileDevice) {
    SpecificMobileDevice["Android"] = "android";
    SpecificMobileDevice["iPad"] = "ipad";
    SpecificMobileDevice["iPhone"] = "iphone";
    SpecificMobileDevice["Desktop"] = "desktop";
    SpecificMobileDevice["Tablet"] = "tablet";
    SpecificMobileDevice["Mobile"] = "mobile";
})(SpecificMobileDevice = exports.SpecificMobileDevice || (exports.SpecificMobileDevice = {}));
var isAndroid = function (userAgent) { return userAgent.toLowerCase().indexOf('android') > -1; };
var isIphone = function (userAgent) { return !!userAgent.match(/iPhone/i); };
var isIpad = function (userAgent) { return !!userAgent.match(/iPad/i); };
exports.getSpecificPlatform = function (userAgent) {
    var _a;
    if (!userAgent)
        return SpecificMobileDevice.Desktop;
    if (isAndroid(userAgent))
        return SpecificMobileDevice.Android;
    if (isIphone(userAgent))
        return SpecificMobileDevice.iPhone;
    if (isIpad(userAgent))
        return SpecificMobileDevice.iPad;
    var genericPlatform = exports.getPlatform(userAgent);
    return (_a = {},
        _a[Device.Desktop] = SpecificMobileDevice.Desktop,
        _a[Device.Mobile] = SpecificMobileDevice.Mobile,
        _a[Device.Tablet] = SpecificMobileDevice.Tablet,
        _a)[genericPlatform] || SpecificMobileDevice.Desktop;
};
//# sourceMappingURL=platform.js.map